// extracted by mini-css-extract-plugin
module.exports = {"content":"SubjectHeading_content__fiR86","heading":"SubjectHeading_heading__3i1vm","cards":"SubjectHeading_cards__2VcdI","container":"SubjectHeading_container__1-joB"};